<div class="row">
  <div class="col">
    <h3>Empresas bloqueadas - Envio em lote</h3>
  </div>

  <div class="col-auto">
    <button class="btn btn-secondary" type="button" (click)="baixarExemploConsultaCNPJ()" placement="bottom"
         ngbTooltip="Exporta um arquivo JSON de exemplo para o envio de um lote de operações.">
      <i class="fa fa-file"></i> Exemplo consulta CNPJ</button>
  </div>

  <div class="col-auto">
    <button class="btn btn-secondary" type="button" (click)="limpar()" placement="bottom">
      <i class="fa fa-file"></i> Limpar</button>
  </div>

  <div class="col-auto">
      <button class="btn btn-primary" (click)="voltar()" type="button">Voltar</button>
    </div>

  <div class="col-auto">
    <button *ngIf="!enviado" [disabled]="!loteCnpjForm.valid || loteCnpjForm.pristine" (click)="onSubmit()"
      class="btn btn-primary" type="button">Enviar</button>
  </div>
</div>
<div class="col">
  <p>Envie um arquivo para consulta de um lote de CNPJ, sendo limitado a 10 CNPJs por arquivo.</p>
</div>
<div class="col">
  <p><em>IMPORTANTE:</em> informar apenas os 8 primeiros dígitos do CNPJ</p>
</div>
<div class="container">
  <form [formGroup]="loteCnpjForm" (validSubmit)="onSubmit()">

    <div class="row">
      <div class="bn-form-group col-md-6">
        <label class="form-label" for="arquivo">Arquivo:</label>
        <div id="customFile">
          <input type="file" accept=".json" class="form-control" id="arquivo" (change)="onFileChange($event)" #fileInput [disabled]="loteEnviado" formControlName="arquivo"/>
        </div>
        <label class="form-label arquivo-selecionado" *ngIf="arquivo?.tipoConteudo">Arquivo de {{labelTipoConteudo}} selecionado para importação</label>
      </div>
    </div>
    <br>
    <div class="bn-form-group">
      <label class="form-label" for="termosContratacaoArea">Termos e condições: </label>
      <textarea style="font-size: 16px;" class="form-control" id="termosContratacaoArea" rows="5" disabled>
    {{termoModalidade}}
      </textarea>
    </div>
    <div class="form-check">
      <input type="checkbox" class="form-check-input" id="checkCiencia" formControlName="checkCiencia">
      <label class="form-label form-check-label" for="checkCiencia">Declaro que estou ciente dos termos e condições aplicáveis</label>
    </div>
  </form>
</div>

<div *ngIf="operacoes?.length > 0 && ocorrencias?.length == 0" class="erros-upload">
  <div class="row">
    <div class="col">
      <h4>Sucesso no envio de lote de operações</h4>
    </div>

    <div class="col-auto">
      <button class="btn btn-secondary" type="button" (click)="baixarTabelaDeOperacoes()" placement="bottom"
        ngbTooltip="Exporta arquivo JSON com as operações recebidas.">
        <i class="fa fa-file"></i> Exportar operações</button>
    </div>
  </div>
</div>

<div *ngIf="ocorrencias?.length > 0" class="erros-upload">
  <div class="row">
    <div class="col">
      <h4>Erros no envio de lote de operações</h4>
    </div>

    <div class="col-auto">
      <button class="btn btn-secondary" type="button" (click)="baixarTabelaDeErros()" placement="bottom"
        ngbTooltip="Exporta arquivo JSON com os erros encontrados.">
        <i class="fa fa-file"></i> Exportar erros</button>
    </div>
  </div>
</div>

<div>
  <div class="container" *ngIf="ocorrencias?.length > 0">
    <div class="table-responsive">
      <table class="table-striped table-bordered">
        <thead>
          <tr>
            <th class="text-center">
              Operação
            </th>
            <th class="text-center">
              Erro(s) encontrado(s)
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let ocorrencia of ocorrencias">
              <td width="20%">
                  {{ ocorrencia.idObjetoValidado }}
              </td>
              <td width="80%">
                  {{ ocorrencia.mensagem }}
              </td>
          </tr>
        </tbody>
      </table>
    </div>
    <p class="obs-erro">Nenhuma operação foi protocolada. Em caso de parâmetro inválido com mensagem "não deve ser nulo", verificar se o nome do parâmetro está correto no JSON enviado.</p>
  </div>
</div>

<bn-loading-overlay></bn-loading-overlay>
